import { render } from "./Login.vue?vue&type=template&id=5a5d2a6a"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script